<template>
  <div id="TelephoneInput">
    <vue-tel-input
      name="telephone"
      v-model="telephone"
      v-bind="bindProps"
      class="form-control telephone-input"
    ></vue-tel-input>
    <Field type="hidden" v-model="telephone" name="telephone"></Field>
  </div>
</template>

<script>
import { Field } from "vee-validate";
export default {
  name: "TelephoneInput",
  components: {
    Field,
  },
  data() {
    return {
      telephone: "",
      bindProps: {
        mode: "international",
        defaultCountry: "GB",
        preferredCountries: ["GB"],
        autocomplete: "off",
        autoFormat: true,
        inputOptions: {
          placeholder: "",
        },
      },
    };
  },
};
</script>
<style>
.vti__dropdown-item {
  font-size: 1rem;
}

.vti__dropdown {
  padding: 0.75rem;
}

.form-control.telephone-input {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding: 0;
}
</style>
